import { memo } from 'react';
import { Checkbox } from 'antd';
import type { PermissionKey } from '@evimo/types/enums/permission-key';

type PermissionChipProps = {
  permissionKey: PermissionKey;
  checked: boolean;
  showDirtyState: boolean;
  isRoleEditable: boolean;
  onTogglePermission: (permissionKey: PermissionKey) => void;
  label: string;
};

export const PermissionChip = memo(function PermissionChip({
  permissionKey,
  checked,
  showDirtyState,
  isRoleEditable,
  onTogglePermission,
  label,
}: PermissionChipProps) {
  return (
    <label
      className={[
        'authorization-permission-chip',
        checked ? 'authorization-permission-chip--checked' : '',
        showDirtyState ? 'authorization-permission-chip--dirty' : '',
        !isRoleEditable ? 'authorization-permission-chip--disabled' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Checkbox
        checked={checked}
        disabled={!isRoleEditable}
        onChange={() => onTogglePermission(permissionKey)}
      />
      <span className="authorization-permission-chip-label">{label}</span>
    </label>
  );
});
